export default __webpack_public_path__ + "static/media/man.ab2ed473.jpeg";